import React from "react";
import Identity from "components/Identity";
import Gallery from "components/Gallery";

/**
 * One screen, no scrolling, one fixed look. Everything is sized against both
 * viewport width and height so the page fits whatever window it lands in.
 */
const App = () => (
  <div className="shell">
    <div className="main">
      <Identity />
      <Gallery />
    </div>
  </div>
);

export default App;
